import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-565c39fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-password" }
const _hoisted_2 = { class: "change-password__heading" }
const _hoisted_3 = { class: "change-password-message" }
const _hoisted_4 = { class: "heading" }
const _hoisted_5 = { class: "password-inputs" }
const _hoisted_6 = { class: "change-password__policy" }
const _hoisted_7 = { class: "change-password__policy__heading" }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IInput = _resolveComponent("IInput")!
  const _component_Message = _resolveComponent("Message")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("login.change_password.message")), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t("login.change_password.title")), 1)
    ]),
    _createElementVNode("form", {
      class: "change-password__form",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitChangePasswordForm && _ctx.submitChangePasswordForm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_IInput, {
          placeholder: _ctx.t('login.change_password.old_password'),
          name: 'oldPassword',
          type: "password",
          modelValue: _ctx.password.old,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password.old) = $event)),
          valid: _ctx.isOldPasswordValid
        }, null, 8, ["placeholder", "modelValue", "valid"]),
        _createVNode(_component_Message, { text: _ctx.oldPasswordFieldErrorMessage }, null, 8, ["text"]),
        _createVNode(_component_IInput, {
          placeholder: _ctx.t('login.change_password.new_password'),
          name: 'currentPassword',
          type: "password",
          modelValue: _ctx.password.current,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password.current) = $event)),
          valid: _ctx.isCurrentPasswordValid
        }, null, 8, ["placeholder", "modelValue", "valid"]),
        _createVNode(_component_Message, { text: _ctx.currentPasswordFieldErrorMessage }, null, 8, ["text"]),
        _createVNode(_component_IInput, {
          placeholder: _ctx.t('login.change_password.confirm'),
          name: 'verifyPassword',
          type: "password",
          modelValue: _ctx.password.confirm,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password.confirm) = $event)),
          valid: _ctx.isConfirmPasswordValid
        }, null, 8, ["placeholder", "modelValue", "valid"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.t("login.change_password.requirements.title")), 1),
          (_ctx.policy)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwordPolicyRequirementObject, (requirement) => {
                  return (_openBlock(), _createElementBlock("li", { key: requirement }, _toDisplayString(requirement.text), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_Message, { text: _ctx.confirmPasswordFieldErrorMessage }, null, 8, ["text"]),
      _createElementVNode("div", {
        class: _normalizeClass({ 'invalid-submission': !this.isSubmissionValid })
      }, [
        _createVNode(_component_SubmitButton, {
          text: _ctx.t('login.change_password.submit_button')
        }, null, 8, ["text"])
      ], 2)
    ], 32)
  ]))
}